/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';
import LoadingIndicator from '@components/LoadingIndicator/LoadingIndicator';
import CanvasEmbed from '@components/CanvasEmbed';
import { PrimaryWrap } from '../Generals/stylesheets/General.style';
import {
  MissingReportMessageWrapper,
  MissingReportMessageContent,
  WarningIconWrapper,
  WarningIcon,
  CanvasWrapper,
  CanvasTitle,
} from './AdminReports.style';

const MissingReportMessage = () => (
  <MissingReportMessageWrapper className="missing-report-container">
    <div className="card">
      <WarningIconWrapper>
        <WarningIcon src="/images/icon-svg/chalktalk-warming.svg" alt="" />
      </WarningIconWrapper>
      <div className="msg-content">
        <MissingReportMessageContent>Coming Soon!</MissingReportMessageContent>
      </div>
    </div>
  </MissingReportMessageWrapper>
);

const ReportContent = ({ adminReports }) => (
  <Iframe
    className="redash-reports-container"
    url={adminReports.report_url}
    width="100%"
    height="100%"
    id="AdminReports"
    display="initial"
    position="relative"
    title="Admin Reports"
    allowFullScreen
  />
);

const AdminReports = ({ adminReports, isLoading, fetchAdminReportsUrl }) => {
  useEffect(() => {
    if (fetchAdminReportsUrl) {
      fetchAdminReportsUrl();
    }
  }, [fetchAdminReportsUrl]);

  if (isLoading) {
    return (
      <LoadingIndicator noBackground partial content="Checking report availability..." />
    );
  }

  const hasCanvas =
    adminReports &&
    Object.prototype.hasOwnProperty.call(adminReports, 'canvas_id') &&
    Object.prototype.hasOwnProperty.call(adminReports, 'canvas_auth_token');
  const hasRedash =
    adminReports && Object.prototype.hasOwnProperty.call(adminReports, 'report_url');

  const renderCanvasEmbed = ({ canvas_id, canvas_auth_token }) => (
    <CanvasWrapper className="canvas-reports-container">
      <CanvasTitle>Data Dashboard</CanvasTitle>
      <CanvasEmbed canvas_id={canvas_id} canvas_auth_token={canvas_auth_token} />
    </CanvasWrapper>
  );

  return (
    <PrimaryWrap fullHeight>
      {hasCanvas && renderCanvasEmbed(adminReports)}
      {!hasCanvas && hasRedash && <ReportContent adminReports={adminReports} />}
      {!hasCanvas && !hasRedash && <MissingReportMessage />}
    </PrimaryWrap>
  );
};

AdminReports.propTypes = {
  adminReports: PropTypes.shape({
    canvas_id: PropTypes.string,
    canvas_auth_token: PropTypes.string,
    report_url: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
  fetchAdminReportsUrl: PropTypes.func,
};

export default AdminReports;
